import React, { useEffect, useRef, useState } from "react";
import block from "bem-cn";
import {  useSelector } from "react-redux";

import SVG from "components/SVG";
import crossSVG from '../img/cross.svg';

import { parseHighlightText, parseOrNot } from "../utils/parseText";

import './NotificationItem.scss';

const b = block('notification-item');

const NotificationItem = ({ item, setActiveItem, hideNotification }) => {
  const locale = useSelector(state => state.locale.locale);

  const textRef = useRef(null);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      const lineHeight = 16;
      const maxLines = 2;
      const maxHeight = lineHeight * maxLines;
      if (el.scrollHeight > maxHeight + 1) {
        setShowButton(true);
      }
    }
  }, [item.text]);

  return (
    <div className={b()} data-id={item.id} data-new={item.new}>
      <div className={b('top')}>
        <div className={b('left')}>
          {item.new && <div className={b('new')}>{locale.new}</div>}
          <div className={b('type', { new: item.new })}>{locale.typesOfNotifications?.[item.tag]}</div>
        </div>
        <div className={b('right')}>
          <div className={b('date')}>{item.date}</div>
          <div className={b('cross-wrapper')} onClick={() => hideNotification(item.id)}>
            <SVG className={b('cross').toString()} svgProps={{ svg: crossSVG }} />
          </div>
        </div>
      </div>

      <div className={b('text')} ref={textRef}>
        {parseOrNot(item.tag) ? parseHighlightText(item.text) : item.text}
      </div>

      {showButton && (
        <div className={b('bottom')} onClick={() => setActiveItem(item)}>
          {locale.showAll}
        </div>
      )}
    </div>
  );
};

export default NotificationItem;
